// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3oSRe","validationTips":"StatementDescriptor_validationTips__1uS1n"};